import React, { useState, useEffect } from 'react';
import './login.css';
import logo from '../home/logo.png';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

const LoginPage: React.FC = () => {
  const [values, setValues] = useState({
    email: '',
    senha: '',
  });
  const history = useHistory();

  useEffect(() => {
    if (localStorage.getItem('user')) {
      history.push('/');
    }
  }, [history]);

  const login = () => {
    if (
      values.email === 'femurn@femurn.com' &&
      values.senha === 'femurn@2020'
    ) {
      localStorage.setItem('user', values.email);
      history.push('/');
    } else {
      toast.error('Credenciais inválidas');
    }
  };

  const keyPress = (event: any) => {
    if (event.key === 'Enter') {
      login();
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <img src={logo} alt="Logo FEMURN" />
        <label>Email</label>
        <input
          type="email"
          name="email"
          onKeyPress={keyPress}
          onChange={(e) => setValues({ ...values, email: e.target.value })}
        />
        <label>Senha</label>
        <input
          onKeyPress={keyPress}
          type="password"
          name="senha"
          onChange={(e) => setValues({ ...values, senha: e.target.value })}
        />
        <button type="submit" onClick={() => login()}>
          Login
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
